const logotext = "{CGMORAH}";
const meta = {
    title: "GIOVANNI MORA - Full Stack Devloper",
    description: "I’m Giovanni Mora data scientist _ Full stack devloper,currently working in Australia",
};

const introdata = {
    title: "I’m Giovanni Mora",
    animated: {
        first: "I love coding",
        second: "I code cool websites",
        third: "I develop web apps",
    },
    description: "I've been DEVELOPING for seventeen years.",
    your_img_url: "https://images.unsplash.com/photo-1607799131608-9a22dd60e25e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=900&q=80",
};

const dataabout = {
    title: "abit about my self",
    aboutme: "I am a JavaScript / PHP  Web Developer (Full-Stack), ReactJS, VueJS, Laravel, CodeIgniter, Symfony, Angular, Bootstrap, Foundation, LESS, Sass, HTML5, CSS3, SQL, with experience in administration and creation of CMS, LMS, eCommerce. Senior in WordPress Develop, DRUPAL developer & MAGENTO Develop, high knowledge in design (Design UX) ... others",
};
const worktimeline = [{
        jobtitle: "Front Developmen - JavaScript (VueJs, ReactJs)",
        where: "Apparent Communications | Digital Agency",
        date: "2022",
    },
    {
        jobtitle: "WordPress / Magento - Full-Developmen",
        where: "Tangible | Digital Agency",
        date: "2021",
    },
    {
        jobtitle: "WordPress & SEO, FB  IG, GOOGLE Ad Development WEB",
        where: "VETEA",
        date: "2021",
    },
    {
        jobtitle: "Back Developmen - PHP WordPress - Laravel",
        where: "AirKeeper | Web Agency",
        date: "2020",
    },
    {
        jobtitle: "Back Developmen - Magento Developer",
        where: "Verdikt | Web Agency",
        date: " 2019",
    },
    {
        jobtitle: "Full Stack Developer - Magento e-Commerce",
        where: "CORVETA",
        date: " 2018",
    },
];

const skills = [{
        name: "JavaScript ",
        value: 99,
    },   
    {
        name: "React",
        value: 85,
    },
    {
        name: "VueJS",
        value: 80,
    },
    {
        name: "PHP",
        value: 99,
    },
    {
        name: "Laravel",
        value: 77,
    },
    {
        name: "CodeIgniter",
        value: 80,
    },
    {
        name: "NodeJS",
        value: 70,
    },
    {
        name: "SQL",
        value: 80,
    },
    {
        name: "HTML5",
        value: 99,
    },
    {
        name: "CSS3",
        value: 99,
    },
    {
        name: "Bootstrap",
        value: 89,
    },
    {
        name: "LESS",
        value: 80,
    },
    {
        name: "Sass",
        value: 80,
    },
    {
        name: "CMS",
        value: 90,
    },
    {
        name: "eCommerce ",
        value: 90,
    },
    {
        name: "LMS",
        value: 90,
    },
    {
        name: "Design UX",
        value: 90,
    },
    {
        name: "SEO",
        value: 97,
    },
    {
        name: "Markting",
        value: 92,
    },

];

const services = [{
        title: "PHP Development and Consulting",
        description: "Based on 15 years of PHP development, my PHP experience enables me to offer robust web portals, B2C and B2B web applications, CMS and other web-based solutions.",
    },
    {
        title: "JavaScript Development",
        description: "I can offer the best end-to-end JavaScript development services for any enterprise to help meet the requirements of each complex project and long-term business objectives. With JavaScript and its different frameworks I can implement complex features in any web project. With square bracket syntax, dynamic writing, prototype-based object orientation, and first-class functions. Along with HTML and CSS, JavaScript is one of the core technologies of the World Wide Web.",
    },
    {
        title: "eCommerce Services",
        description: "I can cover the technical needs related to the technology of an e-commerce business. With my extensive experience in e-commerce I am ready for any challenge.",
    },
    {
        title: "Full-service CMS",
        description: "I am able to design and build cutting-edge web and mobile experiences. I can create end-to-end applications from WordPress and Drupal, from strategy and planning to design and development, as well as complete data migration, extensive API integrations, scalability, performance and long-term orientation and maintenance.",
    },
];

const dataportfolio = [{
        img: "https://picsum.photos/400/?grayscale",
        desctiption: "✓ whuws.com (GSAP, Open Graph)",
        link: "https://whuws.com/",
    },
    {
        img: "https://picsum.photos/400/?grayscale",
        desctiption: "✓ sgac.com.au (WordPress Oxygen Builder, CPT and ACF)",
        link: "https://www.sgac.com.au/",
    },
    {
        img: "https://picsum.photos/400/?grayscale",
        desctiption: "✓ snowplowanalytics.com (WordPress build own theme) ",
        link: "https://snowplowanalytics.com/",
    },
    {
        img: "https://picsum.photos/400/600/?grayscale",
        desctiption: "✓ civilcast.com.au (WooCommerce)",
        link: "https://civilcast.com.au/",
    },
    {
        img: "https://picsum.photos/400/300/?grayscale",
        desctiption: "✓ alliancemetal.com.au (WordPress) ",
        link: "https://www.alliancemetal.com.au/",
    },
    {
        img: "https://picsum.photos/400/700/?grayscale",
        desctiption: "✓ maxtonfox.com.au (WordPress) ",
        link: "https://www.maxtonfox.com.au/",
    },

    {
        img: "https://picsum.photos/400/600/?grayscale",
        desctiption: "✓ dashboard.airkeeper.com.au (Laravel)",
        link: "https://host.airkeeper.com.au/",
    },
    {
        img: "https://picsum.photos/400/300/?grayscale",
        desctiption: "✓ nybeautysalon.com.au (WordPress)",
        link: "https://nybeautysalon.com.au/",
    },
    {
        img: "https://picsum.photos/400/?grayscale",
        desctiption: "✓ tutradingchart.com (Angular) ",
        link: "https://www.tutradingchart.com/",
    },
];

const contactConfig = {
    YOUR_EMAIL: "cgmorah@gmail.com",
    YOUR_FONE: "+61 410 740 600 | +1 818 748 8317 ",
    description: "I have always liked the technology industry. It gives me the freedom to be myself with the people I can serve and help. I am passionate about everything I do, and I will always bring a great vibration and a smile to work. I would like to have the opportunity to talk more with you about any role and how I could use my skills to benefit you.",
    // creat an emailjs.com account 
    // check out this tutorial https://www.emailjs.com/docs/examples/reactjs/
    YOUR_SERVICE_ID: "service_id",
    YOUR_TEMPLATE_ID: "template_id",
    YOUR_USER_ID: "user_id",
};

const socialprofils = {
    github: "https://github.com/cgmorah",
    linkedin: "https://www.linkedin.com/in/cgmorah/",
    twitter: "https://twitter.com/cgmorah",
    behance: "http://www.behance.net/cgmorah",
};
export {
    meta,
    dataabout,
    dataportfolio,
    worktimeline,
    skills,
    services,
    introdata,
    contactConfig,
    socialprofils,
    logotext,
};
